export default __webpack_public_path__ + "static/media/13.d98f8efd.jpg";